<template>
  <div class="xcard">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined> <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn>
    <h3 class="text-center"> Asignaciones </h3>
    <p class="text-center text-primary" style="margin-bottom:0"> <small class="center-block"> <span class="glyphicon glyphicon-exclamation-sign"></span> Puede ver las asignaciones por programa y por cada estudiante </small> </p>

    <div class="row">
      <div class="col-sm-4">
        <div class="form-group form-group-sm">
          <div class="input-group input-group-sm">
            <div class="input-group-addon"> Sede: </div>
            <Sedes :model="sede"/>
          </div>
        </div>
      </div>

      <div class="col-sm-8">
        <div class="form-group form-group-sm">
          <div class="input-group input-group-sm">
            <div class="input-group-addon"> Programa: </div>
            <Programas :model="programa" :bysede="sede.idsede"/>
          </div>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-sm-4">
        <div class="form-group form-group-sm">
          <div class="input-group input-group-sm">
            <div class="input-group-addon"> Mes: </div>
            <Meses :model="mes"/>
          </div>
        </div>
      </div>
    </div>

    
    <Asignacionp :programa="programa.idprograma" :mes="mes"/>

  </div>
</template>

<script>
import Asignacionp from '@/components/AAsignacionByPrograma'
import Programas from '@/components/AProgramasAsignacion'
import Sedes from '@/components/ASedes'
import Meses from '@/components/AMeses'
export default {
  data(){
    return{
      programa: { idprograma:{} },
      sede:{ idsede:{} },
      mes: {idmes:{}},
    }
  },
  components:{ Asignacionp,Programas,Sedes,Meses},
  watch:{
    
  }
}
</script>